import { useScale } from "~/hooks/useScale";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  width: number;
  height: number;
  children: (scale: number) => JSX.Element | null;
  containerRef: React.RefObject<HTMLDivElement>;
};

export function Scale({
  width,
  height,
  className,
  style,
  children,
  containerRef,
}: Props) {
  const scale = useScale(containerRef, width, height);
  return (
    <div ref={containerRef} className={className} style={style}>
      {children(scale)}
    </div>
  );
}
